<template>
    <div class="home">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="superstars_type"><span>3+1管家式服务模式</span></div>
<!--        <div class="wrapper__w" style="width: 85%">-->
        <div class="wrapper__w" style="width: 85%;">
            <img :src="test1" style="display: block;width: 100%;">
            <img :src="test2" style="display: block;width: 100%">
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import test1 from '@/assets/img/test1.jpg'
    import test2 from '@/assets/img/test2.jpg'
    import icon_stra from '@/assets/img/ower01.png'
    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra,test1,test2
            }
        },
        components: {
            NavSecond,Footer
        }
    }
</script>
<style  lang="scss" scoped>
    .superstars_type{
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        color: #010101;
        height: 200px;
        line-height: 250px;
        span{
            position: relative;
            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                margin-left: -16px;
                bottom: -20px;
                width: 32px;
                height: 4px;
                background: #F55E1B;
            }
        }

    }

</style>
